import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import UserDetailsRequestForm from "../../components/sentry/UserDetailsRequestForm.jsx";
import UserDetailsRequestFormResult from "../../components/sentry/UserDetailsRequestFormResult.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import {
  verificationRecoveryRequest,
  resetVerificationStore
} from "../../state/reducers/account/accountActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class VerificationRecovery extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    verificationRecoveryRequest: PropTypes.func.isRequired,
    resetVerificationStore: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "sentry.verification_recovery"
  };

  constructor(props) {
    super(props);

    this.props.resetVerificationStore();
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    this.props.verificationRecoveryRequest(values);
  };

  // -- RENDER -- //

  renderForm = () => {
    const { isFetching, isSuccess, copyKey } = this.props;

    if (isSuccess) {
      return (
        <UserDetailsRequestFormResult copyKey="sentry.verification_recovery_result" />
      );
    }

    return (
      <UserDetailsRequestForm
        isFetching={isFetching}
        copyKey={copyKey}
        onSubmit={this.onSubmit}
      />
    );
  };

  render() {
    const { copyKey, copy } = this.props;

    return (
      <div className="sentry-form">
        <Header as="h3" inverted>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment padded textAlign="left">
          {this.renderForm()}
        </Segment>
        <footer>
          <LinkWithReset to="/">{copy(`${copyKey}.login_cta`)}</LinkWithReset>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.verify.isFetching,
  isSuccess: state.verify.isSuccess,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  verificationRecoveryRequest: data =>
    dispatch(verificationRecoveryRequest(data)),
  resetVerificationStore: () => dispatch(resetVerificationStore())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerificationRecovery);
